import { useRequestURL, useRoute, useRuntimeConfig } from '#imports'
import { onMounted, ref, watchEffect } from 'vue'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { buildStudentVerificationUrl } from './StudentDiscountCTA.utils'

export function useStudentVerificationUrl() {
  const url = ref<ReturnType<typeof buildStudentVerificationUrl>>()
  const error = ref()

  const marketplace = useMarketplace()
  const { user, isUserAuthenticated } = useUserStore()
  const locale = useI18nLocale()

  const { SHEER_ID_STUDENT_DISCOUNT_URL } = useRuntimeConfig().public

  const route = useRoute()

  const logger = useLogger()

  const requestURL = useRequestURL()

  onMounted(() => {
    watchEffect(() => {
      try {
        url.value = buildStudentVerificationUrl({
          authenticated: isUserAuthenticated.value,
          market: marketplace.market,
          bmUserId: user.value.bmUserId,
          currentRoute: route,
          sheerIdUrl: SHEER_ID_STUDENT_DISCOUNT_URL,
          originUrl: requestURL.origin,
          locale,
        })
      } catch (err) {
        logger.error('[CONTENT] error when building student verification url', {
          error: err as Error,
          owners: ['bot-squad-lifecycle-front'],
        })
        error.value = err
      }
    })
  })

  return { url, error }
}
